import { render } from "./LiveCaptions.vue?vue&type=template&id=2758ef48&scoped=true"
import script from "./LiveCaptions.vue?vue&type=script&lang=js"
export * from "./LiveCaptions.vue?vue&type=script&lang=js"

import "./LiveCaptions.vue?vue&type=style&index=0&id=2758ef48&scoped=true&lang=css"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2758ef48"]])

export default __exports__